/* ezink-print-live.js v3 — Size hard filter; never paint Shopify variant over a combo ladder. */
(function (w) {
  function adjustVariant() {
    var n = Number(w.EZINK_PRINT_ADJUST_VARIANT || 0);
    return n > 0 ? n : 0;
  }

  function moneyFormat(root) {
    var wrap = root && root.querySelector("[data-ezink-price-wrap]");
    return (wrap && wrap.getAttribute("data-money-format")) || "${{amount}}";
  }

  function formatMoney(cents, fmt) {
    cents = Math.round(Number(cents) || 0);
    var d = (Math.abs(cents) / 100).toFixed(2);
    var out = String(fmt || "${{amount}}")
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Math.abs(cents) / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, d.replace(".", ","))
      .replace(/\{\{\s*amount\s*\}\}/g, d);
    if (out === (fmt || "${{amount}}")) out = "$" + d;
    return (cents < 0 ? "-" : "") + out;
  }

  function parsePayload(root) {
    var node = root.querySelector("[data-ezink-print-combo-json]");
    if (!node) return null;
    var payload;
    try {
      payload = JSON.parse(node.textContent || "{}");
    } catch (err) {
      return null;
    }
    var pricesNode = root.querySelector("[data-ezink-print-prices-json]");
    if (pricesNode) {
      try {
        payload.price_pack = JSON.parse(pricesNode.textContent || "{}");
      } catch (err2) {
        payload.price_pack = null;
      }
    }
    return payload;
  }

  function normSize(v) {
    return String(v || "")
      .toLowerCase()
      .replace(/["'″]/g, "")
      .replace(/[×x]/g, "x")
      .replace(/\s+/g, "")
      .replace(/x+/g, "x");
  }

  function normCombo(key, v) {
    v = String(v || "").replace(/\s+/g, " ").trim();
    if (key === "Size") return normSize(v);
    var t = v.toLowerCase();
    if (key === "Drill Hole") {
      if (!t || t.indexOf("no hole") !== -1 || t.indexOf("no drill") !== -1) return "";
    }
    if (key === "Folding Options") {
      if (!t || t.indexOf("no fold") !== -1 || t.indexOf("flat") === 0) return "";
    }
    if (key === "Perforation") {
      if (!t || t.indexOf("no perf") !== -1) return "";
    }
    if (key === "Numbering") {
      if (!t || t.indexOf("no number") !== -1) return "";
    }
    return v;
  }

  function fieldVal(root, name) {
    var want = String(name || "");
    var hit = "";
    root.querySelectorAll("[data-ezink-print-key]").forEach(function (el) {
      if ((el.getAttribute("data-ezink-print-key") || "") !== want) return;
      if (el.disabled) return;
      var wrap = el.closest(".ezink-print-field");
      if (wrap && wrap.classList.contains("is-combo-hidden")) return;
      hit = el.value || "";
    });
    return hit;
  }

  function comboIndex(root, payload, keyFilter) {
    var keys = payload && payload.combo_keys;
    var combos = payload && payload.combos;
    if (!keys || !combos || !combos.length) return -1;
    var sizeI = keys.indexOf("Size");
    var wantSize = sizeI >= 0 ? normCombo("Size", fieldVal(root, "Size")) : "";
    var values = {};
    keys.forEach(function (k) {
      values[k] = normCombo(k, fieldVal(root, k));
    });
    var best = -1;
    var bestScore = -1;
    for (var r = 0; r < combos.length; r++) {
      var row = combos[r];
      if (wantSize && sizeI >= 0 && normCombo("Size", row[sizeI] || "") !== wantSize) continue;
      var score = wantSize ? 50 : 0;
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        if (key === "Size") continue;
        var have = values[key] || "";
        var cell = normCombo(key, row[i] || "");
        if (!have || !cell) continue;
        if (have === cell) score += 10;
      }
      if (score > bestScore) {
        bestScore = score;
        best = r;
      }
    }
    return best;
  }

  function lookupPacked(pack, comboIndex, qty) {
    if (!pack || comboIndex < 0 || !(qty > 0)) return 0;
    var qtys = pack.q || [];
    var rows = pack.s || [];
    var row = rows[comboIndex];
    if (!row) return 0;
    var exact = -1;
    for (var i = 0; i < qtys.length; i++) {
      if (Number(qtys[i]) === qty) {
        exact = i;
        break;
      }
    }
    if (exact >= 0 && Number(row[exact]) > 0) return Number(row[exact]);
    for (var j = 0; j < qtys.length; j++) {
      if (Number(qtys[j]) >= qty && Number(row[j]) > 0) return Number(row[j]);
    }
    for (var k = qtys.length - 1; k >= 0; k--) {
      if (Number(row[k]) > 0) return Number(row[k]);
    }
    return 0;
  }

  function selectedQty(root) {
    var qty = 0;
    var run = root.querySelector(".product-form__item--run-qty select, select[data-index='option1']");
    if (run) {
      qty = parseInt(String(run.value).replace(/,/g, ""), 10) || 0;
      if (qty > 0) return qty;
    }
    root.querySelectorAll("select.single-option-selector").forEach(function (el) {
      var wrap = el.closest(".selector-wrapper, .ezink-print-field");
      var label = wrap && wrap.querySelector("label");
      var name = ((label && label.textContent) || "").replace(/\s+/g, " ").trim().toLowerCase();
      if (name.indexOf("quantity") !== -1) {
        var n = parseInt(String(el.value).replace(/,/g, ""), 10);
        if (n > 0) qty = n;
      }
    });
    return qty > 0 ? qty : 0;
  }

  function isRush(root) {
    var pill = root.querySelector("[data-ezink-turnaround-val].is-active");
    if (pill) return (pill.getAttribute("data-ezink-turnaround-val") || "") === "Rush";
    var sel = root.querySelector("[data-ezink-turnaround] select, .product-form__item--turnaround select");
    if (sel) return String(sel.value || "") === "Rush";
    return false;
  }

  function setsQty(root) {
    var inp = root.querySelector("[data-ezink-qty-input]");
    var n = parseInt(inp && inp.value, 10);
    return n > 0 ? n : 1;
  }

  function variantCents(root) {
    var sel = root.querySelector("[data-product-select]") || root.querySelector("select[name='id']");
    var id = sel && sel.value;
    var jsonEl = root.querySelector("[data-product-json]") || document.querySelector("[data-product-json]");
    var data = null;
    if (jsonEl) {
      try {
        data = JSON.parse(jsonEl.textContent || "{}");
      } catch (err) {
        data = null;
      }
    }
    if (data && data.variants && id) {
      var n = parseInt(id, 10);
      for (var i = 0; i < data.variants.length; i++) {
        if (data.variants[i].id === n) return Number(data.variants[i].price) || 0;
      }
    }
    return 0;
  }

  function hasLadder(root) {
    var payload = parsePayload(root);
    var pack = payload && payload.price_pack;
    return !!(pack && pack.s && pack.s.length && payload.combos && payload.combos.length);
  }

  function quoteCents(root) {
    var payload = parsePayload(root);
    var sets = setsQty(root);
    if (payload && payload.price_pack && payload.price_pack.s && payload.price_pack.s.length) {
      var idx = comboIndex(root, payload);
      var qty = selectedQty(root);
      var cents = lookupPacked(payload.price_pack, idx, qty);
      if (cents > 0) {
        if (isRush(root)) cents *= 2;
        return cents * sets;
      }
      return 0;
    }
    var base = variantCents(root);
    return base > 0 ? base * sets : 0;
  }

  function extraCents(root) {
    var quote = quoteCents(root);
    var base = variantCents(root) * setsQty(root);
    var extra = quote - base;
    return extra > 0 ? extra : 0;
  }

  function ensureQuoteField(form) {
    var el = form.querySelector("[data-ezink-print-quote]");
    if (el) return el;
    el = document.createElement("input");
    el.type = "hidden";
    el.name = "properties[_print_quote]";
    el.setAttribute("data-ezink-print-quote", "");
    form.appendChild(el);
    return el;
  }

  function paint(root) {
    var form = root.querySelector("form[action*='/cart/add']") || root.querySelector("form.product-form");
    var cents = quoteCents(root);
    if (!(cents > 0)) return 0;
    var fmt = moneyFormat(root);
    document.querySelectorAll("[data-ezink-price-total]").forEach(function (el) {
      el.hidden = false;
      el.textContent = formatMoney(cents, fmt);
    });
    var sets = setsQty(root);
    var each = sets > 0 ? Math.round(cents / sets) : cents;
    document.querySelectorAll("[data-ezink-price-unit]").forEach(function (el) {
      el.hidden = false;
      el.textContent = "(" + formatMoney(each, fmt) + " each)";
    });
    if (form) ensureQuoteField(form).value = String(cents);
    root.setAttribute("data-ezink-print-cents", String(cents));
    return cents;
  }

  function collectProps(fd) {
    var props = {};
    fd.forEach(function (val, key) {
      var m = String(key).match(/^properties\[([^\]]+)\]$/);
      if (m) props[m[1]] = String(val);
    });
    return props;
  }

  function addPrintThenAddon(form, root) {
    var fd = new FormData(form);
    var id = fd.get("id");
    var qty = parseInt(fd.get("quantity") || "1", 10) || 1;
    var props = collectProps(fd);
    var extra = extraCents(root);
    var addon = adjustVariant();
    if (extra > 0 && addon > 0 && !props["_Artwork set"]) {
      props["_Artwork set"] = "p" + Date.now().toString(36);
    }
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: Number(id), quantity: qty, properties: props })
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw new Error(body.description || body.message || "Could not add to cart");
          return body;
        });
      })
      .then(function () {
        if (!(addon > 0) || extra < 1) return;
        return fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          credentials: "same-origin",
          body: JSON.stringify({
            id: addon,
            quantity: extra,
            properties: {
              _print_adjust: "1",
              "_Artwork set": props["_Artwork set"] || ""
            }
          })
        });
      })
      .then(function () {
        w.location.href = "/cart";
      });
  }

  function printRoots() {
    return document.querySelectorAll("[id^='ProductSection-'], [data-ezink-print-live='1']");
  }

  function paintAll() {
    printRoots().forEach(function (root) {
      if (root.querySelector("[data-ezink-print-combo-json]")) paint(root);
    });
  }

  function initRoot(root) {
    if (!root || root.getAttribute("data-ezink-print-price") === "1") return;
    if (!root.querySelector("[data-ezink-print-combo-json]")) return;
    root.setAttribute("data-ezink-print-price", "1");
    var form = root.querySelector("form[action*='/cart/add']") || root.querySelector("form.product-form");
    if (form) {
      form.addEventListener("submit", function (evt) {
        paint(root);
        if (!(extraCents(root) > 0) || !(adjustVariant() > 0)) return;
        evt.preventDefault();
        addPrintThenAddon(form, root).catch(function (err) {
          w.alert(err.message || "Could not add to cart");
        });
      });
    }
    setTimeout(function () {
      paint(root);
    }, 80);
    setTimeout(function () {
      paint(root);
    }, 400);
  }

  function boot() {
    printRoots().forEach(initRoot);
    if (document.documentElement.getAttribute("data-ezink-print-price-doc") === "1") return;
    document.documentElement.setAttribute("data-ezink-print-price-doc", "1");
    document.addEventListener(
      "change",
      function (evt) {
        var t = evt.target;
        if (!t) return;
        if (t.getAttribute && t.getAttribute("data-ezink-print-key")) {
          setTimeout(paintAll, 0);
          setTimeout(paintAll, 60);
          return;
        }
        if (t.classList && t.classList.contains("single-option-selector")) {
          setTimeout(paintAll, 0);
          setTimeout(paintAll, 60);
        }
      },
      true
    );
    document.addEventListener("ezink-print-combo", function () {
      setTimeout(paintAll, 0);
      setTimeout(paintAll, 30);
    });
    if (w.jQuery) {
      jQuery(document).on("variantChange", function () {
        setTimeout(paintAll, 40);
        setTimeout(paintAll, 200);
      });
    }
  }

  w.EZINKPrintPrice = {
    quoteCents: quoteCents,
    paint: paint,
    hasLadder: hasLadder,
    extraCents: extraCents
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
